/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'
export type GroupApproversBackofficeUserIdentityFragment = {
  __typename?: 'BackofficeUserIdentity'
  id: string
  firstName: string
  lastName: string
  email: string | null
  organizationId: string
}

export const GroupApproversBackofficeUserIdentityFragmentDoc = gql`
    fragment GroupApproversBackofficeUserIdentity on BackofficeUserIdentity {
  id
  firstName
  lastName
  email
  organizationId
}
    `
